import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Transfer1 = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.85 4.45a.8.8 0 0 0-.82-.82l-4.35.11a.8.8 0 1 0 .04 1.6l2.369-.06-9.215 9.214a.8.8 0 0 0 1.132 1.132L14.2 6.432 14.14 8.8a.8.8 0 1 0 1.6.04l.11-4.39Zm4.276 3.924a.8.8 0 0 1 0 1.132L10.91 18.72l2.369-.06a.8.8 0 1 1 .04 1.6l-4.35.11a.8.8 0 0 1-.82-.82l.11-4.39a.8.8 0 0 1 1.6.04l-.06 2.368 9.194-9.194a.8.8 0 0 1 1.132 0Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Transfer1
